import { Button, Card, Col, Form, Input, Row, Select } from "antd";
import React, { useState } from "react";
import { states } from "../../../../../../utils/Util";

function PersonalInformation({ data }) {
  const [checked, setChecked] = useState(false);
  return (
    <Row>
      <Col span={24}>
        <Card
          title="Personal Information"
          extra={
            !checked ? (
              <span className="onclick-text" onClick={() => setChecked(true)}>
                Edit
              </span>
            ) : null
          }
        >
          {checked ? (
            <Row>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                  labelWrap={{ span: 8 }}
                >
                  <Form.Item label="Date Of Birth" required>
                    <Input />
                  </Form.Item>
                  <Form.Item label="SSN (or ITIN)" required>
                    <Input />
                  </Form.Item>
                  <Form.Item label="Government Issued ID">
                    <Input />
                  </Form.Item>
                  <Form.Item label="Issuing State/Territory">
                    <Select options={states} />
                  </Form.Item>
                </Form>
              </Col>
              <Col span={24}>
                <Row gutter={[8, 0]}>
                  <Col>
                    <Button type="primary">Save</Button>
                  </Col>
                  <Col>
                    <Button onClick={() => setChecked(false)}>Cancel</Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Date Of Birth">
                <p>--</p>
              </Form.Item>
              <Form.Item label="SSN (or ITIN)">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Government Issued ID">
                <p>--</p>
              </Form.Item>
              <Form.Item label="Issuing State/Territory">
                <p>--</p>
              </Form.Item>
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default PersonalInformation;
